export default function shouldFetchMiddleware({ getState }) {
	return next => (currentAction) => {
		const action = {
			...currentAction,
		};

		if (action.payload && typeof action.payload.promise === 'function') {
			const { shouldFetch } = action.payload;
			if (!shouldFetch || shouldFetch(getState())) {
				action.payload.promise = action.payload.promise();
			}
		}

		return next(action);
	};
}



// WEBPACK FOOTER //
// ./src/redux/middleware/should-fetch-middleware.js